export const COMPETITION_ID = "-ONZAGgj070Ym0rnEzEu";
